<template>
  <div class="h-100">
    <CardWrapper
      @dblclick="$router.push('/incomes')"
      :has-access="access"
      :is-loading="preloader"
    >
      <template #title>
        СБОРЫ
      </template>
      <template #icon>
        <FeesIcon />
      </template>
      <div class="px-3 py-2 fees">
        <div
          class="fees-list-item pa-1"
          v-for="(item, id) in list"
          :key="item.title"
        >
          <div>
            <div class="fees-row-name">{{item.title}}</div>
            <div class="font-weight-bold">{{item.curIncome}}</div>
          </div>
          <div class="fees-percent font-weight-bold" :class="getClass(item.growth)">
            {{item.growth}}%
            <v-icon
              :title="!item.growth ? 'Нет данных для сравнения' :'По отношению к аналогичному периоду прошлого года'"
              medium
              :class="getClass(item.growth)"
            >{{getIcon(item.growth)}}</v-icon>
          </div>
        </div>
      </div>
      <template #permissionDenied>
        <div v-if="!access" class="text-md-center blue-grey--text">
          <i class="material-icons">warning</i>
          <br>У Вас нет прав доступа к информации по сборам!
        </div>
      </template>
    </CardWrapper>
  </div>
</template>

<script>
import store from '@/store'
import { cur } from '../../helpers/currensy'
import CardWrapper from "../ui/CardWrapper.vue";
import FeesIcon from "../ui/icons/FeesIcon.vue";
export default {
  components: {FeesIcon, CardWrapper},
  data() {
    return {}
  },
  computed: {
    incomes: {
      get() {
        return store.getters['incomes/getIncomes']
      },
      set(value) {
        store.commit('incomes/setIncomes', value)
      },
    },
    access: {
      get() {
        return store.getters['chechAccess']('charges')
      },
    },
    growthY: function() {
      return this.getIncomesGrowth(this.incomes.Y, this.incomes.prevYear)
    },
    growthM: function() {
      return this.getIncomesGrowth(this.incomes.M, this.incomes.prevYearMonth)
    },
    growthQ: function() {
      return this.getIncomesGrowth(this.incomes.Q, this.incomes.prevYearQuarter)
    },
    list() {
      return [
        {title: 'С начала года:', growth: this.growthY, curIncome: this.cur(this.getIncomesSum(this.incomes.Y))},
        {title: 'С начала квартала:', growth: this.growthQ, curIncome: this.cur(this.getIncomesSum(this.incomes.Q))},
        {title: 'С начала месяца:', growth: this.growthM, curIncome: this.cur(this.getIncomesSum(this.incomes.M))},
      ]
    },
    preloader: {
      get() {
        return store.getters['incomes/getIncomesPreloader']
      },
      set(value) {
        store.commit('incomes/setIncomesPreloaderState', value)
      },
    },
  },
  methods: {
    cur,
    getIncomesSum: function(arr) {
      arr = arr || []
      let sum = 0
      arr.forEach(element => {
        sum += parseFloat(element.Incomes)
      })
      return sum.toFixed(2)
    },
    getIncomesGrowth: function(currentArr, prevArr) {
      let incomes = Math.round(this.getIncomesSum(currentArr))
      let prevIncomes = Math.round(this.getIncomesSum(prevArr))

      if (!prevIncomes) return 0

      let result = ((parseFloat(incomes) - parseFloat(prevIncomes)) / parseFloat(prevIncomes)) * 100

      return result.toFixed(0)
    },
    getClass(number) {
      if (!number) return 'orange--text'
      return number > 0 ? 'green--text' : 'red--text'
    },
    getIcon(number) {
      if (!number) return 'history'
      return number > 0 ? 'arrow_upward' : 'arrow_downward'
    },
  },
}
</script>
<style scoped>
.fees {
  font-size: 12px;
}
.fees-list-item {
  display: grid;
  grid-template-columns: 1fr 66px;
  grid-template-rows: auto;
  border-bottom: 1px solid #EEEEEE;
  i {
    font-size: 18px !important;
  }
}
.fees-row-name {
  color: #5F6368;
}
.fees-percent {
  display: flex;
  align-items: end;
  justify-content: end;
}
</style>
